// extracted by mini-css-extract-plugin
export var articleType = "styles-module--articleType--11e4f";
export var beige = "styles-module--beige--07ade";
export var blue = "styles-module--blue--d8379";
export var icon = "styles-module--icon--00451";
export var largeLandscape = "styles-module--largeLandscape--f8b0b";
export var largeSquare = "styles-module--largeSquare--91b4b";
export var link = "styles-module--link--dcb78";
export var media = "styles-module--media--3d7a5";
export var mediaWrapper = "styles-module--mediaWrapper--66535";
export var none = "styles-module--none--3c824";
export var podcast = "styles-module--podcast--a9c6b";
export var red = "styles-module--red--2e606";
export var smallLandscape = "styles-module--smallLandscape--490c1";
export var smallSquare = "styles-module--smallSquare--c0840";
export var subline = "styles-module--subline--2f94f";
export var textVisualText = "styles-module--textVisualText--1edb8";
export var withoutArticleType = "styles-module--withoutArticleType--b493b";
export var wrapper = "styles-module--wrapper--07a9f";